import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import { doctor_login } from './../api';

import { useAppContext } from './../AppContext';
import CONFIG from './../config';

import useService from './../services';




function DoctorLoginPage() {
  const { setUser, setIsAuthenticated, state, setState, setPatientInfo, setDoctorInfo,setRole } = useAppContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [loginRole, setLoginRole] = useState('patient'); // default to patient
  //const { invokeLambda } = useService();

  // const CONFIG = {
  //   region: process.env.REACT_APP_REGION,
  //   userPoolId: process.env.REACT_APP_USER_POOL_ID,
  //   providerPoolId: process.env.REACT_APP_PROVIDER_POOL_ID,
  //   userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  //   identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  //   apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  //   lambdaAppointment: process.env.REACT_APP_LAMBDA_APPOINTMENT,
  //   lambdaPatientLookup: process.env.REACT_APP_LAMBDA_PATIENT_LOOKUP,
  // };

  const handleSubmit = (event) => {



    event.preventDefault();

    console.log("Submitting login form with email:", email, "and role:", loginRole);
    setError('');

    if (!email.trim() || !password.trim()) {
      setError('Please enter both email and password.');
      return;
    }

    setLoading(false);

    console.log("CONFIG", CONFIG);

    doLogin(email.trim(), password.trim());

    // doctor_login(email.trim(), password.trim()).then((response) => {
    //   if (response.statusCode === 404) {
    //     setIsAuthenticated(false);
    //     console.log(error);
    //     setError('Authentication failed');
    //   } else {
    //     console.log(response);
    //     console.log(response.body);
    //     setUser(response.body);
    //     setLoading(false);
    //     setIsAuthenticated(true);
    //     if (response.body?.role === 'doctor') {
    //       navigate('/doctor-dashboard'); // adjust route as needed
    //     }
    //      if (response.body?.role?.toLowerCase() === 'patient') {
    //        navigate('/patient-dashboard'); // adjust route as needed
    //      }
    //   }
    // }).catch((error) => {
    //   setIsAuthenticated(false);
    //   console.log(error);
    //   setError('Authentication failed');
    // }).finally(() => {

    // });

    // doLogin(email.trim(), password.trim()).then(() => {
    //   setIsAuthenticated(true);
    //   navigate('/doctor-dashboard'); // adjust route as needed
    // }).catch((error) => {
    //   setIsAuthenticated(false);
    //   console.log(error);
    //   setError('Authentication failed');
    // });
  };


  async function doLogin(email, password) {
    console.log(CONFIG);
    try {
      if (loginRole === "doctor") {
        console.log("Logging in as doctor...");
        const data = await cognitoRequest("InitiateAuth", {
          AuthFlow: "USER_PASSWORD_AUTH",
          ClientId: CONFIG.providerPoolClientId,
          AuthParameters: { USERNAME: email, PASSWORD: password },
        });
        console.log("Login successful:", data);

        localState.idToken = data.AuthenticationResult.IdToken;
        localState.accessToken = data.AuthenticationResult.AccessToken;
        localState.email = email;
      }
      else {
        const data = await cognitoRequest("InitiateAuth", {
          AuthFlow: "USER_PASSWORD_AUTH",
          ClientId: CONFIG.userPoolClientId,
          AuthParameters: { USERNAME: email, PASSWORD: password },
        });
        console.log("Login successful:", data);

        localState.idToken = data.AuthenticationResult.IdToken;
        localState.accessToken = data.AuthenticationResult.AccessToken;
        localState.email = email;
      }

      await fetchAWSCredentials(localState);

      const userResponse = await fetch(
        COGNITO_URL,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target":
              "AWSCognitoIdentityProviderService.GetUser",
          },
          body: JSON.stringify({
            AccessToken:
              localState.accessToken, //auth.AccessToken,
          }),
        }
      );

      //const userData = await userResponse.json();

      const userData = await getAwsUserInformation();

      console.log("User data:", userData);

      const userRoleAttr = userData.UserAttributes;

      

      const result = Object.fromEntries(
        userRoleAttr.map(item => [item.Name, item.Value])
      );

      console.log("User role attribute:", result);


      localState.user = result;
      setState(localState);

      if (loginRole === "doctor") {
        let providerProfile = await getProviderProfile(localState.accessToken, localState.email);
        localState.doctorInfo = providerProfile;
        localState.providerId = providerProfile?.provider_id || null;

        setState(localState);

        setRole("doctor");
        setIsAuthenticated(true);
        navigate('/doctor-dashboard');
      }
      else if (loginRole === "patient") {

        let newState = await getPatientInformation(localState);
        newState.patientId = newState.patientInfo?.patient_id || null;
        setState(newState);
        setRole("patient");
        setIsAuthenticated(true);
        navigate('/patient-dashboard');
      }

      

    } catch (err) {
      console.log("Login error: " + err.message);

    } finally { }
  }

  const COGNITO_URL = CONFIG.awsUrl; // `https://cognito-idp.${CONFIG.region}.amazonaws.com/`;

  async function getAwsUserInformation() {
    try {
    const userResponse = await fetch(
        COGNITO_URL,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target":
              "AWSCognitoIdentityProviderService.GetUser",
          },
          body: JSON.stringify({
            AccessToken:
              localState.accessToken, //auth.AccessToken,
          }),
        }
      );

      const userData = await userResponse.json();
      console.log("User data:", userData);
      return userData;
    } catch (err) {
      console.log("Error fetching AWS user information:", err);
      throw err;
    }

  }

  async function getPatientInformation(currentState) {
    // 1. Look up by email via direct Lambda
    try {
      //const r = await invokeLambda(CONFIG.lambdaPatientLookup, { action: "lookup", email: currentState.email });
      console.log("Looking up patient information for email:", currentState.email);
      const r = await invokeLambda(CONFIG.lambdaPatientLookup, { action: "lookup", email: currentState.email });
      console.log("Patient information fetched:", r);
      if (r && r.found && r.patient_id) {
        currentState.patientId = r.patient_id;
        currentState.patientInfo = r;
        console.log("Patient information fetched successfully:", currentState);
        return currentState;
      }
      if(!r || !r.found) {
        console.log("Patient not found, inserting new patient information...");
        const insertResult = await insertPatientInformation();
        console.log("Insert patient information result:", insertResult);
        if(insertResult) {
          const updatedState = await getPatientInformation(currentState); // Retry fetching after insertion
          return updatedState;
        }
      }
    } catch (e) { 
      console.error("Error occurred while fetching patient information:", e);
      return null;
    }
  }

  async function insertPatientInformation() {
    try {
          
            const r = await invokeLambda(CONFIG.lambdaPatientLookup, {
                action: "register", first_name: localState.user.given_name, last_name: localState.user.family_name,
                dob: "", phone: "", email: localState.user.email, channel: "web-portal",
            });

            return r;


    } catch (e) { 
      console.error("Error occurred while inserting patient information:", e);
      return null;
    }
  }


  async function getProviderProfile(jwtToken, email) {

    let url = CONFIG.apiEndpoint + '/provider/profile';

    url += `?email=${encodeURIComponent(email)}`;

    const response = await fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${jwtToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };


  async function invokeLambda(fn, payload) {
    const url = `https://lambda.${CONFIG.region}.amazonaws.com/2015-03-31/functions/${fn}/invocations`;
    const body = JSON.stringify(payload);

    const headers = await signRequest("POST", url, body);
    const res = await fetch(url, { method: "POST", headers, body });
    const text = await res.text();
    let result; try { result = JSON.parse(text); } catch { result = text; }
    if (res.status !== 200) {
      console.log(`✗ Lambda HTTP ${res.status}`, result);
      throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
    }
    if (result && result.errorMessage) {
      console.log(`✗ Lambda function error`, result);
      throw new Error(result.errorMessage);
    }

    return result;
  }

  async function signRequest(method, url, body) {
    const c = localState.awsCreds;
    const p = new URL(url);
    const now = new Date();
    const dt = now.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
    const ds = dt.slice(0, 8);
    const ph = await sha256hex(body);
    const ch = `content-type:application/json\nhost:${p.host}\nx-amz-date:${dt}\nx-amz-security-token:${c.sessionToken}\n`;
    const sh = "content-type;host;x-amz-date;x-amz-security-token";
    const cr = [method, p.pathname, "", ch, sh, ph].join("\n");
    const sc = `${ds}/us-east-1/lambda/aws4_request`;
    const ss = ["AWS4-HMAC-SHA256", dt, sc, await sha256hex(cr)].join("\n");
    let sk = await hmac("AWS4" + c.secretAccessKey, ds);
    sk = await hmac(sk, "us-east-1"); sk = await hmac(sk, "lambda"); sk = await hmac(sk, "aws4_request");
    const sig = Array.from(new Uint8Array(await hmac(sk, ss))).map(b => b.toString(16).padStart(2, "0")).join("");
    return {
      "Content-Type": "application/json", "X-Amz-Date": dt, "X-Amz-Security-Token": c.sessionToken,
      "Authorization": `AWS4-HMAC-SHA256 Credential=${c.accessKeyId}/${sc}, SignedHeaders=${sh}, Signature=${sig}`
    };
  }

  async function hmac(key, msg) {
    const k = typeof key === "string" ? new TextEncoder().encode(key) : key;
    const ck = await crypto.subtle.importKey("raw", k, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
    return new Uint8Array(await crypto.subtle.sign("HMAC", ck, new TextEncoder().encode(msg)));
  }

  async function sha256hex(msg) {
    const h = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(msg));
    return Array.from(new Uint8Array(h)).map(b => b.toString(16).padStart(2, "0")).join("");
  }

  async function cognitoRequest(action, body) {
    const res = await fetch(COGNITO_URL, {
      method: "POST",
      headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": `AWSCognitoIdentityProviderService.${action}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || data.__type || "Cognito error");
    return data;
  }
  let localState = {
    idToken: null,
    accessToken: null,
    email: null,
    patientId: null,
    awsCreds: null,
    user: null,
    patientInfo: null,
    doctorInfo: null
  };
  async function fetchAWSCredentials(currentState) {
    const idpKey = loginRole === "patient" ? `cognito-idp.${CONFIG.region}.amazonaws.com/${CONFIG.userPoolId}` : `cognito-idp.${CONFIG.region}.amazonaws.com/${CONFIG.providerPoolId}`;
    const logins = { [idpKey]: currentState.idToken };

    const r1 = await fetch(`https://cognito-identity.${CONFIG.region}.amazonaws.com/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityService.GetId" },
      body: JSON.stringify({
        AccountId: process.env.REACT_APP_AWS_ACCOUNT_ID,
        IdentityPoolId: CONFIG.identityPoolId,
        Logins: logins
      }),
    });
    const id = await r1.json();
    if (!r1.ok) throw new Error(id.message || "GetId failed");

    const r2 = await fetch(`https://cognito-identity.${CONFIG.region}.amazonaws.com/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityService.GetCredentialsForIdentity" },
      body: JSON.stringify({ IdentityId: id.IdentityId, Logins: logins }),
    });
    const cd = await r2.json();
    if (!r2.ok) throw new Error(cd.message || "GetCredentials failed");

    currentState.awsCreds = {
      accessKeyId: cd.Credentials.AccessKeyId,
      secretAccessKey: cd.Credentials.SecretKey,
      sessionToken: cd.Credentials.SessionToken,
    };
    setState(currentState);
    console.log("AWS credentials fetched successfully:", currentState.awsCreds);
    console.log("AWS credentials OK (expire: " + new Date(cd.Credentials.Expiration * 1000).toLocaleTimeString() + ")");
  }

  return (
    <div className="page-card centered-card">
      <div className="padding-lg">
        <h2 className="page-heading">Login</h2>
        <p className="page-copy text-muted">
          Enter your credentials to access your physician workspace.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group spaced">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="form-control"
              placeholder="doctor@example.com"
              required
            />
          </div>

          <div className="form-group spaced">
            <label className="form-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="form-control"
              placeholder="Enter your password"
              required
            />
          </div>

          <div className="form-group spaced">
            <label className="form-label">Role</label>
            <select className="form-select" value={loginRole} onChange={(event) => setLoginRole(event.target.value)}>
              <option value="doctor">Doctor</option>
              <option value="patient">Patient</option>
            </select>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <button type="submit" className="btn btn-primary w-100" disabled={loading} style={{ backgroundColor: '#0b5ed7' }}>
            {loading ? <span className="spinner"></span> : 'Sign in'}
          </button>
          <div className="row">
            <div className='col-6' >
              <p className="text-muted text-small mt-3 mb-0">
                {/* <button
                  type="button"
                  className="link-button"
                  onClick={() => navigate('/forgot-password')}
                >
                  Forgot password?
                </button> */}
              </p>
            </div>
            <div className='col-6 text-end' >
              <p className="text-muted text-small mt-3 mb-0">
                <button
                  type="button"
                  className="link-button"
                  onClick={() => navigate('/patient-registration')}
                >
                  Register as a new patient?
                </button>
              </p>
            </div>
          </div>




        </form>
      </div>
    </div>
  );
}

export default DoctorLoginPage;
